import React, { useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux"
import { Box, Slide } from "@chakra-ui/react"
import { Text, CloseButton, Flex, Button, Divider, Fade } from "@chakra-ui/react";
import { setAreaDrawing, clearAreaDrawing, setArea } from "../../redux/actions/map.actions"
import { setDownloadPointsBoxOpen, downloadPointsAction } from "../../redux/actions/points.actions"
import { FiEdit2, FiCornerUpLeft, FiDownload } from "react-icons/fi";

export default function DownloadPointsBox() {
  const dispatch = useDispatch()
  const { isDownloadPointsBoxOpen, downloadPointsPending } = useSelector(state => state.pointsStates)
  const isAreaDrawingEnabled = useSelector(state => state.mapStates.isAreaDrawingEnabled)
  const selectedArea = useSelector(state => state.mapStates.selectedArea)
  const type = useSelector(state => state.mapStates.type)


  const onClosePointsBox = () => {
    dispatch(setDownloadPointsBoxOpen())
  }

  const enableAreaSelect = () => {
    dispatch(setAreaDrawing(true))
  }

  const clearAreaSelect = () => {
    dispatch(clearAreaDrawing())
  }

  const onDownloadPoints = async (coordinates) => {
    dispatch(downloadPointsAction(coordinates, type))
  }


  useEffect(() => {
    if (!isDownloadPointsBoxOpen) {
      dispatch(setArea(null))
      dispatch(setAreaDrawing(false))
    }
  }, [isDownloadPointsBoxOpen, dispatch])

  return (
    <Slide direction="right" in={isDownloadPointsBoxOpen} style={{ marginTop: "60px", width: 300, height: 300, zIndex: 1200 }}>
      <Box
        backgroundColor={"white"}
        boxShadow="xl"
        borderBottomLeftRadius={5}
        position="absolute"
        top={0}
        right={0}
        width={'100%'}
        zIndex={1200}>
        <CloseButton size="lg" onClick={onClosePointsBox} />
        <Box p={3}>
          <Flex py={3} justify="space-between">
            <Button size="sm" leftIcon={<FiEdit2 />} onClick={enableAreaSelect} colorScheme="teal" variant="solid" isDisabled={isAreaDrawingEnabled}>Select area</Button>
            <Button size="sm" leftIcon={<FiCornerUpLeft />} onClick={clearAreaSelect} colorScheme="orange" variant="solid" isDisabled={!isAreaDrawingEnabled}>Clear</Button>
          </Flex>
          {selectedArea !== null ? <>
            <Fade in={true}>
              <Divider py={2} orientation="horizontal" />
              <Text m={4} fontSize="md" textAlign="center" fontWeight="bold">Selected area properties</Text>
              <Box>
                <Flex justify="space-between">
                  <Text fontSize="sm">Perimeter: </Text> <Text fontSize="sm" fontWeight="bold">{selectedArea.polygonPerimeter} km</Text>
                </Flex>
                <Flex justify="space-between">
                  <Text fontSize="sm">Area: </Text> <Text fontSize="sm" fontWeight="bold">{selectedArea.polygonArea} km<sup>2</sup></Text>
                </Flex>
              </Box>
              <Divider py={2} orientation="horizontal" />
              <Flex justify="center" py={2}>
                <Button size="sm" leftIcon={<FiDownload />} loadingText="Please wait..." isLoading={downloadPointsPending} colorScheme="blue" variant="solid" onClick={() => onDownloadPoints(selectedArea.polygonCoordinates)}>Download as GeoJSON</Button>
              </Flex>
            </Fade></> : null}
        </Box>
      </Box>
    </Slide>

  )
}
